export enum WheelchairIconType {
  dark,
  white,
  box,
}
